var map = {
	"./basketball-active.webp": 1471,
	"./basketball.webp": 1472,
	"./bg.webp": 1473,
	"./football-active.webp": 1474,
	"./football.webp": 1475,
	"./games-active.webp": 1476,
	"./games.webp": 1477,
	"./information.webp": 1478,
	"./live-streaming-cover.webp": 1479,
	"./lv-active-bg.webp": 1480,
	"./video-bg.webp": 1481,
	"./video-icon.webp": 1482,
	"./vs.webp": 1483
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 461;